import { meshComponent } from './Mesh'
import { props, createGeometry } from '../geometries/CylinderGeometry'

export default meshComponent('Cylinder', props, createGeometry)
